import cloneDeep from 'lodash/cloneDeep'

import { FunctionValue } from '@makyoapp/makyo-common'

import { useCreateColumnContext } from '@/context/CreateColumnContext'
import { generateColumnNameV2 } from '@/shared/ag-grid'
import FunctionV2 from '@/components/FunctionV2'
import { useGridV2Context } from '@/components/GridV2/contexts/GridV2Context'

/**
 * Grid V2 Function Field
 */
export default function FieldFunction() {
  const { id, value, setValue } = useCreateColumnContext()

  const { table, gridModal } = useGridV2Context()
  const columnID = gridModal?.column?.id

  const handleChangeValue = (v: FunctionValue) => {
    if (!table) return

    let name = value.name

    if (value.functionOptions.functionValue?.item.title !== v.item.title) {
      name = generateColumnNameV2(v.item.title, table, columnID)
    }

    setValue((prev) => {
      const clonePrev = cloneDeep(prev)
      return {
        ...clonePrev,
        name,
        functionOptions: {
          ...clonePrev.functionOptions,
          functionValue: v,
        },
      }
    })
  }

  return (
    <FunctionV2
      id={id}
      className='mt-4 mb-2'
      value={value.functionOptions.functionValue}
      onChange={handleChangeValue}
    />
  )
}
